import { createSvgIcon } from '@mui/material/utils';
import React, { memo } from 'react';
const SvgIcon = createSvgIcon([
    React.createElement("circle", { key: '0', fill: '#FFFFFF', className: 'st0', cx: '12', cy: '12', r: '11' }),
    React.createElement("path", { key: '1', d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z' }),
], 'InspectionStatusActive');
const InspectionStatusActiveIcon = function (props) {
    return React.createElement(SvgIcon, Object.assign({}, props));
};
export default memo(InspectionStatusActiveIcon);
